// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../css/colors.css'","darkOrange":"#D8630F","delivery":"DeliveryPage_delivery__FHGfX"};